import React from 'react';
import ChatControl from './ChatControl';
import ChatMessage from './ChatMessage';
import { ChatContainer } from './style';

const ChatArea = () => {
    return (
        <ChatContainer>
          <ChatMessage />
          <ChatControl />
        </ChatContainer>
    );
}

export default ChatArea;